/**
 * Department-scoped search for the Vox Mox header.
 *
 * The department <select> narrows results using Shopify's native search query
 * syntax (`product_type:"…"`), which needs no app and no filter configuration.
 * A plain GET form cannot merge two fields into one `q` parameter, so this
 * element intercepts submit and builds the URL itself.
 *
 * Without JavaScript the form still submits `q=<term>` and search works
 * normally — the department is simply ignored.
 */
class VmSearch extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.input = this.querySelector('input[type="search"]');
    this.scope = this.querySelector('[data-search-scope]');

    if (!this.form || !this.input || !this.scope) return;

    this.onSubmit = this.onSubmit.bind(this);
    this.form.addEventListener('submit', this.onSubmit);
  }

  disconnectedCallback() {
    this.form?.removeEventListener('submit', this.onSubmit);
  }

  onSubmit(event) {
    // A highlighted predictive-search suggestion wins — it navigates itself.
    if (this.querySelector('[aria-selected="true"] a')) return;

    const scope = this.scope.value.trim();
    if (!scope) return; // "All departments" — let the form submit as-is.

    const term = this.input.value.trim();

    event.preventDefault();

    const query = term ? `${term} product_type:"${scope}"` : `product_type:"${scope}"`;
    const url = new URL(this.form.getAttribute('action'), window.location.origin);
    url.searchParams.set('q', query);
    url.searchParams.set('options[prefix]', 'last');
    url.searchParams.set('type', 'product');

    window.location.assign(url.toString());
  }
}

customElements.define('vm-search', VmSearch);
